import { appQueryClient } from '../../../../provider'
import type { RestCounterType } from '../../types/RestCounter'

export const accumulatorsReportCachekeys = {
  one: (type: RestCounterType, report_id?: number) => [
    'accumulators_report',
    report_id,
    type
  ]
}

export const accumulatorsReportInvalidations = {
  invalidateReport: (type: RestCounterType, report_id: number) => {
    appQueryClient.invalidateQueries({
      queryKey: accumulatorsReportCachekeys.one(type, report_id)
    })
  }
}
